import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Legacy cleanup: auth is now cookie-only (httpOnly), never in JS storage.
localStorage.removeItem("tl_token");
sessionStorage.removeItem("tl_token");

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Une erreur est survenue. Réessayez.";
  if (typeof d === "string") return d;
  if (d.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function openBlob(url, filename, download = false) {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  if (download) {
    const a = document.createElement("a");
    a.href = href;
    a.download = filename || "fichier";
    a.click();
  } else {
    window.open(href, "_blank", "noopener,noreferrer");
  }
  setTimeout(() => URL.revokeObjectURL(href), 60000);
}

export const eur = (v) =>
  v === null || v === undefined ? "À confirmer" : `${Number(v).toLocaleString("fr-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const fmtDate = (s) => (s ? new Date(s.length === 10 ? s + "T12:00:00" : s).toLocaleDateString("fr-BE") : "");
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("fr-BE") : "");
